module.exports = {"unit":{"meter":"Meter","square":"Quadratmeter","cubic":"Kubikmeter","piece":"Stück","flatrate":"Pauschale Einheit","kilo_watt_hours":"Kilowattstunden"},"time":{"month":"Monat","quartal":"Quartal","year":"Jahr"},"currency":{"euro":"Euro","dollar":"Doller"}};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/de/culture.php
// module id = sQL5
// module chunks = 1